const MIC_ANCHOR_SEL = "[data-read21-mic-anchor]";
const MIN_ANCHOR_PX = 16;
const MIN_VISIBLE_AREA = 500;

export function needsExplicitMicTapNudge(itemDetails, stageInfo) {
  if (!itemDetails || !stageInfo) return false;
  const t = itemDetails.type;
  if (t !== "word" && t !== "sentence") return false;
  if (stageInfo.startImmediately) return false;
  const bothNoMic = !stageInfo.microphone && !itemDetails.microphone;
  if (bothNoMic) return false;
  return true;
}

/**
 * Pick the best `[data-read21-mic-anchor]` for arrow aim: `querySelector` can hit a hidden
 * duplicate (0×0 or off-screen); we prefer the largest in-viewport hit.
 * @returns {DOMRectReadOnly | null}
 */
export function getBestMicAnchorClientRect() {
  if (typeof document === "undefined") return null;
  const list = document.querySelectorAll(MIC_ANCHOR_SEL);
  if (!list.length) return null;

  const vw = typeof window !== "undefined" ? window.innerWidth : 0;
  const vh = typeof window !== "undefined" ? window.innerHeight : 0;

  let bestInView = null;
  let bestInViewArea = 0;
  let bestAny = null;
  let bestAnyGeom = 0;

  list.forEach((el) => {
    const r = el.getBoundingClientRect();
    const geom = Math.max(0, r.width) * Math.max(0, r.height);
    if (r.width >= MIN_ANCHOR_PX && r.height >= MIN_ANCHOR_PX && geom > bestAnyGeom) {
      bestAnyGeom = geom;
      bestAny = r;
    }
    const il = Math.max(r.left, 0);
    const it = Math.max(r.top, 0);
    const ir = Math.min(r.right, vw);
    const ib = Math.min(r.bottom, vh);
    const vis = Math.max(0, ir - il) * Math.max(0, ib - it);
    if (r.width >= MIN_ANCHOR_PX && r.height >= MIN_ANCHOR_PX && vis >= MIN_VISIBLE_AREA && vis > bestInViewArea) {
      bestInViewArea = vis;
      bestInView = r;
    }
  });

  if (bestInView) return bestInView;
  if (bestAny && bestAnyGeom >= MIN_ANCHOR_PX * MIN_ANCHOR_PX) return bestAny;
  return null;
}

export function getMicTapArrowFallbackRect() {
  if (typeof window === "undefined") return new DOMRect(160, 280, 80, 80);
  const w = window.innerWidth;
  const h = window.innerHeight;
  const size = 72;
  const left = w / 2 - size / 2;
  const top = Math.max(120, Math.min(h * 0.48 - size / 2, h - size - 120));
  return new DOMRect(left, top, size, size);
}
